
import { Component, Vue } from "vue-property-decorator";
import { WechatService, OrderService } from "src/services";
import { Toast, Dialog } from "vant";
import dayjs from "dayjs";
import { CHECK_STATUS, ORDER_STATUS } from "src/enums";
import { Pay, tools } from "src/utils";
import udialog from "src/components/dialog";

Component.registerHooks([
    "beforeRouteEnter",
    "beforeRouteLeave",
    "beforeRouteUpdate" // for vue-router 2.2+
]);


@Component({
    components:{
        udialog
    }
})
export default class OfteUser extends Vue
{
    /**
     * 先买后约订单状态映射
     * @private
     * @returns boolean
     */
     private OrderPendingStatusMap: any = {
        Cancel: 0,          // 已取消
        ToPay: 1,           // 待付款
        Pending: 2,         // 待预约
        Booked: 3,          // 已预约
        Refunded: 7,        // 已退款
        Completed: 4        // 已完成
    };

    /**
     * 先买后约订单状态映射
     * @private
     * @returns boolean
     */
    private OrderPendingStatusStrMap: any = {
        0: '已取消',
        1: '待付款',
        2: '待预约',
        3: '已预约',
        4: '已完成',
        7: '已退款',
    };

    /**
     * 体检订单状态映射
     * @private
     * @returns boolean
     */
     private PhysicalOrderStatusMap: any = {
        Cancel: 0,          // 已取消
        ToPay: 1,           // 待付款
        Booked: 2,          // 已预约(未超额)
        Payed: 3,           // 已预约(已超额)
        Completed: 4,       // 已完成
        ReportUpload: 5,    // 报告已上传
        Refunding: 6,       // 退款中
        Refunded: 7,        // 已退款
        Expired: 8,         // 已失效
        Booking: 77,        // 预约中
        Changing: 88,       // 改约中
        Canceling: 99       // 取消中
    };

    /**
     * 是否显示弹框
     * @private
     * @returns boolean
     */
    private isShowDialog: boolean = false;

    /**
     * 弹框名称
     * @private
     * @returns boolean
     */
    private dialogName: string = "";

     /**
     * 弹框内容
     * @private
     * @returns boolean
     */
    private dialogContent: string = "";

    /**
     * 时间处理
     * @private
     * @returns 
     */
    private dayjs: any = dayjs;

    /**
     * 温馨提示
     * @private
     * @returns 
     */
    private showOverlay: boolean = false;

    /**
     * 是否显示日期
     * @private
     * @returns 
     */
    private showDate: boolean = false;

    /**
     * 自选项目选中
     * @private
     * @returns any
     */
    private fixedCollapseActive: any = [];

    /**
     * 权益加项目选中
     * @private
     * @returns any
     */
    private rightsCollapseActive: any = [];

    /**
     * 自选项目选中
     * @private
     * @returns any
     */
    private collapseActiveNames: any = [];

    /**
     * 订单详情
     * @private
     * @returns 
     */
    private orderDetail: any = {};
    
    /**
     * 根据预约日期判断能否取消，(今天12点前或前一天不能取消)
     * @private
     * @returns boolean
     */
    private get isCancel(): boolean
    {
        let orderDate = this.orderDetail.physicalTime;
        // 判断体检日期是不是明天
        let isTomorrow = dayjs().add(1,"day").format("YYYY-MM-DD") === dayjs(orderDate).format("YYYY-MM-DD");
        // 判断是否是今天
        let isToDay = dayjs(orderDate).format("YYYY-MM-DD") === dayjs().format("YYYY-MM-DD");
        if(isTomorrow)
        {
            return false;
        }
        // else if(isToDay && (+dayjs(orderDate).format("hh") < 12))
        else if(isToDay)
        {
            return false;
        }

        return  true;
    }

    /**
     * 订单id
     * @private
     * @returns number
     */
    private get orderId(): any
    {
        return this.$route.params && this.$route.params.id || null;
    }

    /**
     * 报告id
     * @private
     * @returns number
     */
     private get reportId(): any
    {
        if(this.$route.query && this.$route.query.reportId)
        {
           return this.$route.query.reportId;
        }

        return null;
    }

    /**
     * 是否已读
     * @private
     * @returns number
     */
     private get isRead()
    {
        if(this.$route.query && this.$route.query.isRead)
        {
           return this.$route.query.isRead;
        }

        return null;
    }

    /**
     * 页面是否回退-h5环境
     * @private
     * @returns boolean
     */
    private get goback(): boolean
    {
        if(this.$route.query && this.$route.query.goback)
        {
           return true;
        }

        return false;
    }

    /**
     * 组件创建钩子
     * @private
     * @returns void
     */
    private created(): void
    {
        if (!tools.isWechat()) // h5支付跳转
        {
            if (this.goback)
            {
                if (localStorage.getItem("h5Pay"))
                {
                    Dialog.confirm({
                        title: "支付结果",
                        message: "请确定微信支付是否已完成?",
                        confirmButtonText: "已完成支付",
                        cancelButtonText: "重新支付"
                    })
                    .then(() =>
                    {
                        localStorage.removeItem("h5Pay");
                        this.pendingDetail();
                    })
                    .catch(() =>
                    {
                        localStorage.removeItem("h5Pay");
                        this.pendingDetail();
                    });
                }
            }
        }
        if(this.orderId)
        {
            this.pendingDetail();
        }
        
    }

    /**
     * 获取订单详情
     * @private
     * @param {params}
     * @returns {Promise<void>}
     */
    private async pendingDetail(): Promise<void>
    {
        try
        {
            let {content: result} =  await OrderService.instance.pendingDetail(this.orderId);

            if(result)
            {
                this.orderDetail = result.data;
            }
        }
        catch(err)
        {
            Toast(err);
        }
        
    }

    /**
     * 查看报告
     * @private
     * @returns string
     */
    private onShowReport(): any
    {
        // this.$router.push({name:"reportAppointmentList"});
        // 未读跳转授权
        // if(!this.isRead) {
        //         this.$router.push({name: "reportLogin", query: {id: this.reportId + ""}});
        // } else {
        // // 已读跳详情
        //     this.$router.push({name: "reportAppointmentDetail", query: {id: this.reportId + ""}});
        // }
        if(!this.orderDetail.isAuth) {
            this.$router.push({name: "reportQuery", query: {id: this.orderDetail.reportId + ""}});
            // 本地存储数据
            let data = {
                    id: this.orderDetail.employerMemberId, 
                    name: this.orderDetail.memberName,
                    phone:this.orderDetail.memberPhone,
            }
            this.$store.dispatch("setReportParams",data)

        } else {
            this.$router.push({name: "reportAppointmentDetail", query: {id: this.orderDetail.reportId + ""}});
        }


    }

    /**
     * 组件进来之前
     * @private
     * @returns void
     */
    private beforeRouteEnter(to, from, next): void
    {
        let appid = localStorage.getItem("appid");
        if (!tools.isAndroid() && `/${appid}${to.path}` !== location.pathname)
        {
           location.assign(`/${appid}${to.fullPath}`);
        }
        else
        {
            next();
        }
    }

    /**
     * 继续支付
     * @private
     * @param {params}
     * @returns {Promise<void>}
     */
    private async proceedPay(): Promise<void>
    {
        this.$router.push({name: "pay", query:{orderNo: this.orderDetail.pendingOrderNo}});
        // try
        // {
        //     let {content: result} =  await OrderService.instance.proceedPay(this.orderId);

        //     if(result)
        //     {
        //         if(result.data.orderStatus !=2)
        //         {
        //             // Pay.onBridgeReady(result.data, this.getOrderDetail);
        //             this.$router.push({name: "pay", query:{orderNo: result.data.orderNo}});
        //         }
        //         else
        //         {
        //             this.getOrderDetail();
        //         }
                
        //     }
        // }
        // catch(err)
        // {
        //     Toast(err);
        // }
        
    }

    /**
     * 显示日期弹框
     * @private
     * @returns void
     */
    private showDateModal(): void
    {
        this.showDate = true;
    }

    /**
     * 立即预约体检
     * @private
     * @returns void
     */
    private onGoSubscribe(): void
    {
        this.$router.push({ name:"order-submit-subscribe", query:{ orderId: this.orderId, orderKind: this.orderDetail.orderKind }})
    }

    /**
     * 详情
     * @private
     * @returns void
     */
    private onSpecialDetail(id: string): void
    {
        this.$router.push({name:"rightsDetail", params:{id: id}})
    }

    /**
     * 确定改约
     * @private
     * @returns void
     */
    private onDateConfirm(date: string,physicalTimePeriod: string ): any
    {
        if(!date) return;

        let data = dayjs(date).format("YYYY-MM-DD");
            Dialog.confirm({
            title: "预约日期",
            message: `是否确定预约${data} ${physicalTimePeriod}体检`
        })
        .then(async() => {
            try
            {
                let result:any =  await OrderService.instance.modifiedOrderDate(this.orderDetail.id, data, physicalTimePeriod);

                if(result.code == 1000)
                {
                    this.showOverlay = true;
                }
                else
                {
                    Toast({
                        duration: 1000,
                        message: "预约成功"
                    });
                    this.pendingDetail();
                    // this.$router.push({name: "orderDetail", params:{id: this.orderDetail.id}});
                }
            }
            catch(err)
            {               
                Toast(err);
            }
            finally
            {
                this.showDate = false;
            }
            
        });
    }
    
    /**
     * 取消订单
     * @private
     * @param {params}
     * @returns {Promise<void>}
     */
    private onCancelOrder(): void
    {
        Dialog.confirm({
        title: "取消订单",
        message: "是否确定取消订单? 取消后需要重新预约"
        })
        .then(async() => {
            try
            {
                let  result: any =  await OrderService.instance.cancelOrder(this.orderDetail.id);
                if(result.code == 1000)
                {
                    this.showOverlay = true;
                }
                else
                {
                    Toast.success("取消成功!");
                    this.pendingDetail();
                }
            }
            catch(err)
            {
                Toast(err);
            }
        });
    }

    /**
     * 取消先买后约订单
     * @private
     * @param {params}
     * @returns {Promise<void>}
     */
     private onCancelPendingOrder(): void
    {
        Dialog.confirm({
            title: "取消订单",
            message: "是否确定取消订单? 取消后需要重新购买"
        })
        .then(async() => {
            try
            {
                let  result: any =  await OrderService.instance.pendingCancel(this.orderId);
                if(result.code == 1000)
                {
                    this.showOverlay = true;
                }
                else
                {
                    Toast.success("取消成功!");
                    this.pendingDetail();
                }
            }
            catch(err)
            {
                Toast(err);
            }
        });
    }

    /**
     * 申请退款
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async onRequestRefund(): Promise<void>
    {
        Dialog.confirm({
            title: "申请退款",
            message: "是否确定申请退款？"
        })
        .then(async() => {
            try
            {
                let  result: any =  await OrderService.instance.pendingCancel(this.orderId);
                if(result.code == 1000)
                {
                    this.showOverlay = true;
                }
                else
                {
                    Toast.success("取消成功!");
                    this.pendingDetail();
                }
            }
            catch(err)
            {
                Toast(err);
            }
        });
    }

    /**
     * 显示提示
     * @private
     * @returns void
     */
    private showTip(remark: string,name:string): void
    {
        // Dialog.alert({
        //     messageAlign: "left",
        //     confirmButtonColor: "#00d5c1",
        //     message: remark,
        //     confirmButtonText: "确定"
        // });

        this.dialogName = name
        this.dialogContent = remark
        this.isShowDialog = true
    }

    /**
     * 跳转页面
     * @private
     * @returns void
     */
    private onGopage(name: string): void
    {
        this.$router.push({name});
    }

    /**
     * 跳转地图
     * @private
     * @returns void
     */
    private async openMap(hospitalOut: any): Promise<any>
    {
        if(hospitalOut)
        {
            let lat = hospitalOut.latitude;
            let lng =hospitalOut.longitude;;
            let address = hospitalOut.address;
            let orgName = hospitalOut.hospitalName;

            if(tools.isWechat())
            {
                let currentUrl = location.href;
                let {content: result} = await WechatService.instance.getWechatJSSDK(currentUrl);
                if(result.data)
                {
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: result.data.appId, // 必填，公众号的唯一标识
                        timestamp: result.data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: result.data.nonceStr, // 必填，生成签名的随机串
                        signature: result.data.signature, // 必填，签名
                        jsApiList: ["openLocation"] // 必填，需要使用的JS接口列表
                    });

                    wx.ready(function()
                    {
                        wx.openLocation({
                            latitude: parseFloat(lat), // 纬度，范围为-90~90，负数表示南纬
                            longitude: parseFloat(lng), // 经度，范围为-180~180，负数表示西经
                            scale: 14, // 缩放比例
                            name: orgName,
                            address: address, // 地图缩放级别,整形值,范围从1~28。默认为最大
                            infoUrl: ""
                        });
                    });
                }
            }
            else
            {
                // 腾讯地图
                // let href = `http://apis.map.qq.com/uri/v1/marker?marker=coord:${lat},${lng};addr:${this.orgDetailInfo.org_name}`;
                // 高德
                let href = `http://uri.amap.com/marker?position=${lng},${lat}&name=${orgName}&coordinate=gaode&callnative=1`;
                window.open(href);
            }

        }

    }

    /**
     * 复制
     * @param str 
     */
    private async copyOrderNo(str): Promise<void>
    {
        let save = function (e) {
            e.clipboardData.setData("text/plain", str);
            e.preventDefault();
        };
        let input = document.createElement("input");
        input.value = str;
        document.body.appendChild(input);
        input.select();
        input.setSelectionRange(0, input.value.length), document.execCommand("Copy");
        document.body.removeChild(input);
        Toast({
            message: "复制成功",
            duration: 1000
        });
    }

    /**
     * @description 跳转到评价页面
     * @private
     * @returns 
     */
    private evaluate({ id, orderEvaluationId }): void {
        this.$router.push({ name: "orderEvaluate", params: { id: id }, query: { orderEvaluationId: orderEvaluationId } })
    }

}
